import { render, staticRenderFns } from "./EmploisReferences.vue?vue&type=template&id=4b017d02&scoped=true"
import script from "./EmploisReferences.vue?vue&type=script&lang=js"
export * from "./EmploisReferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b017d02",
  null
  
)

export default component.exports